import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

interface MobileSegmentedTabsItem {
  key: string;
  label: string;
  href: string;
  icon: LucideIcon;
}

interface MobileSegmentedTabsProps {
  items: MobileSegmentedTabsItem[];
  activeKey: string;
}

export function MobileSegmentedTabs({ items, activeKey }: MobileSegmentedTabsProps) {
  return (
    <div className="rounded-2xl border bg-muted/40 p-1 md:hidden" role="tablist" aria-label="Kitchen library sections">
      <div className="grid gap-1" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = item.key === activeKey;

          return (
            <Link
              key={item.key}
              to={item.href}
              role="tab"
              aria-selected={isActive}
              className={cn(
                'flex min-w-0 flex-col items-center gap-1 rounded-xl px-2 py-2 text-center text-xs font-medium transition-colors',
                isActive
                  ? 'bg-background text-foreground shadow-sm'
                  : 'text-muted-foreground hover:bg-background/70 hover:text-foreground'
              )}
            >
              <Icon className="h-4 w-4" />
              <span className="truncate">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
